<template>
  <client-only>
    <v-menu
      v-if="!isMobile"
      v-model="userNavigation"
      class="!wd-fixed !wd-right-0 !wd-top-18 !md:wd-left-2/3 !lg:wd-left-8/11"
      :min-width="320"
      :max-width="320"
      :z-index="999"
      :close-on-content-click="false"
    >
      <member-route-list
        v-bind="memberRouteListProps"
        header-class="wd-flex wd-items-center wd-gap-4 wd-p-5 wd-pt-10 wd-relative"
        nickname-class="wd-mb-1 wd-truncate wd-text-left"
        close-btn-class="wd-absolute wd-top-2 wd-right-2"
        membership-level-name-class="wd-text-otempsm"
      />
    </v-menu>

    <v-navigation-drawer
      v-else
      v-model="userNavigation"
      class="menu-navigation wd-w-full !wd-h-full !wd-top-0"
      width="0"
      temporary
      location="right"
      touchless
    >
      <member-route-list
        v-bind="memberRouteListProps"
        header-class="wd-flex wd-items-center wd-gap-4 wd-p-5 wd-pt-10 wd-relative"
        nickname-class="!wd-mb-2 wd-truncate wd-text-left"
        close-btn-class="wd-absolute wd-top-2 wd-right-2"
        membership-level-name-class="wd-text-omd"
      />
    </v-navigation-drawer>
  </client-only>
</template>

<script lang="ts" setup>
import MemberRouteList from '@/components/member/MemberRouteList.vue'

import { useVuetify } from '@/composition/useUtil'

const { $store } = useNuxtApp()

const vuetify = useVuetify()

const isMobile = computed(() => vuetify.display.smAndDown.value)
const userNavigation = computed({
  get: () => $store.state.userNavigation,
  set: val => {
    $store.dispatch('setUserNavigation', val)
  },
})
const memberRouteListProps = computed(() => {
  return {
    isNavbar: true,
    isCloseBtnShown: true,
    avatarSize: isMobile.value ? 80 : 48,
    avatarClass: 'wd-w-20 wd-h-20 xs:wd-w-12 xs:wd-h-12',
    onItemClick: closeNavigation,
    onClose: closeNavigation,
  }
})

function closeNavigation() {
  userNavigation.value = false
}
</script>

<style lang="scss" scoped>
.menu-navigation {
  z-index: 9;
}
</style>
